<template>
    <div uk-sticky="top: 1500000px;">
        <div class="topNav uk-visible@m" style="padding-top: 10px; padding-bottom: 10px; width: 100%; background-color: #333; border-bottom: #ffcb05 1px solid" uk-sticky="top: 15000px;" >
<!--          <div class="uk-alert-primary" style="margin-top: -15px; padding: 5px 5px 0px 5px">
            <p class="uk-text-center" style="margin-bottom: 5px">
              A scheduled maintenance of our Servers will be carried out on Friday, May 27, 2022, between the hours of 1:00 pm. and 5:00 pm.
              During this time the website will be unavailable
            </p>
          </div>-->
            <div class="uk-container uk-container-expand">
                <div class="uk-float-right" style="margin-right: 20px !important;">
<!--                  <router-link to="/privacy"  class=" uk-text-uppercase uk-text-small uk-light uk-margin-right topLinkColor">Privacy</router-link>
                  <router-link to="/dataProtection"  class=" uk-text-uppercase uk-text-small uk-light uk-margin-right topLinkColor">Data Protection </router-link>-->
                  <a href="http://ncumediagroup.com/" target="_blank" class="uk-text-uppercase uk-text-small uk-light uk-margin-right topLinkColor" style="color: white;">NCU Media</a>
                    <a href="https://ncuadvance.org/" target="_blank" class="uk-text-uppercase uk-text-small uk-light uk-margin-right topLinkColor" style="color: white;">NCU Foundation</a>
                    <a href="https://aeorion.ncu.edu.jm" target="_blank" class="uk-text-uppercase uk-text-small uk-light uk-margin-right topLinkColor" style="color: white;">Aeorion</a>
                   <!-- <a href="https://news.ncu.edu.jm/CorporateDirectory/default.aspx?searchstring=&filterstring=&DepV=" target="_blank" class="uk-text-uppercase uk-text-small uk-light uk-margin-right topLinkColor" >Email</a>
                   -->

                    <a href="https://gmail.com" target="_blank" class="uk-text-uppercase uk-text-small uk-light uk-margin-right topLinkColor" >Email</a>
                    <a href="https://www.collegecentral.com/ncujm/" target="_blank" class="uk-text-uppercase uk-text-small uk-light uk-margin-right topLinkColor" >College Central</a>

                    <router-link to="/searchDepartment" class="uk-text-uppercase uk-text-small uk-light uk-margin-right topLinkColor" >Directory</router-link>
                    <router-link to="/records"  class=" uk-text-uppercase uk-text-small uk-light uk-margin-right topLinkColor">Records</router-link>
                    <a href="http://hwrc.ncu.edu.jm" target="_blank" class="uk-text-uppercase uk-text-small uk-light uk-margin-right topLinkColor" >Library</a>
                    <router-link to="/careers" class="uk-text-uppercase uk-text-small uk-light uk-margin-right topLinkColor" >Careers</router-link>

                    <router-link to="/alumni" class="uk-text-uppercase uk-text-small uk-light uk-margin-right topLinkColor" > Alumni</router-link>

<!--                    <router-link to="/newsandevents" class="uk-text-uppercase uk-text-small uk-light uk-margin-right topLinkColor">News & Events</router-link>-->
<!--                    <router-link to="/parents" class="uk-text-uppercase uk-text-small uk-light uk-margin-right topLinkColor" > Parents</router-link>
                    <router-link to="/students" class="uk-text-uppercase uk-text-small uk-light uk-margin-right topLinkColor">Students</router-link>-->
                    <!--<router-link to="/facultystaff" class="uk-text-uppercase uk-text-small uk-light uk-margin-right topLinkColor">Faculty & Staff</router-link>-->
                    <router-link to="/giving" class="uk-text-uppercase uk-text-small uk-light uk-margin-right topLinkColor" style="border-top: 2px solid gold; padding: 4px">Give</router-link>
                    <router-link to="/request_information" class="  uk-text-small uk-margin-right" style=" color: gold;  font-weight: bold ">Admissions Information</router-link>
                  <router-link to="/keywordsearch">
                    <input class="uk-input uk-form-width-medium uk-form-small searchStyle" type="text"
                           placeholder="Keyword Search"
                           style="border-radius: 15px; background-color: #888888; border: none; color: gold"

                    >
                  </router-link>

                </div>
            </div>
        </div>
        <div class="" style="background-color: #033860; border-bottom: 1px solid #ffcb05;  ">
            <div class="uk-container uk-container-large">
                <nav class="uk-navbar-container uk-margin uk-margin-remove-bottom uk-flex uk-flex-between " id="navi" uk-navbar="dropbar: true;" style="background-color: transparent">
                    <div class="uk-navbar-left">

                        <router-link class="uk-navbar-item uk-logo te" to="/" style="">
                            <img src="../../assets/ncu-logo2_inverted.png" style="" alt="">
                        </router-link>

                    </div>
<!--                  <div class="uk-container uk-container-small uk-hidden@l">-->
<!--                    <div class=" applybtn " id="applybtn" >-->
<!--                      <a href="https://apply.ncu.edu.jm" target="_blank"-->
<!--                         class="uk-text-uppercase uk-light uk-button upSize "-->
<!--                         style="background: rgb(255, 215, 3); color:  #033860; border-radius: 5px; font-weight: bold; padding-left: 15px; padding-right: 15px; "-->
<!--                      >Apply Now</a>-->
<!--                    </div>-->
<!--                  </div>-->
                    <div class="uk-navbar-left">
                        <ul class="uk-navbar-nav uk-visible@l" >
                            <li><router-link to="/" class="uk-text-uppercase uk-light upSize">  Home</router-link></li>
                            <li>
                                <a href="#" class="uk-text-uppercase uk-light upSize">About Us</a>
                                <div class="uk-navbar-dropdown uk-navbar-dropdown-width-3">
                                    <div class="uk-navbar-dropdown-grid uk-child-width-1-2" uk-grid>

                                        <div>
                                            <ul class="uk-nav uk-navbar-dropdown-nav uk-text-left">
                                                <li class="uk-nav-header uk-text-capitalize">School</li>
                                                <li class="uk-nav-divider"></li>
                                                <li @click="closeDropbar"><router-link to="/accreditation">  Accreditation & Affiliates</router-link></li>



                                                <!--<li><router-link to="/faqs">FAQ's</router-link></li>-->
                                                <li @click="closeDropbar"><router-link to="/meetourleaders"> Meet Our Leaders</router-link></li>
                                                <li @click="closeDropbar"><router-link to="/president_message"> President's Message</router-link></li>
                                                <li>
                                                    <a target="_blank" href="/ETHOS_DOCUMENT.pdf"> Our Ethos</a>
                                                </li>
                                                <!--<li><a href="#">Ventures</a></li>-->
                                            </ul>
                                        </div>
                                        <div>
                                            <ul class="uk-nav uk-navbar-dropdown-nav uk-text-left">
                                                <li class="uk-nav-header uk-text-capitalize">General</li>
                                                <li class="uk-nav-divider"></li>
                                                <li><router-link to="/adminunits"> Non-Academic Departments and Offices</router-link></li>

                                                <!--<li><router-link to="/diversity">Diversity & Inclusion</router-link></li>-->

                                                <li><router-link to="/futurencu"> Mission, Vision & Core Values</router-link></li>
                                                <li><router-link to="/wearencu"> Who we are</router-link></li>
                                                <li><a href="/NCUStrategicPlan2024FINAL.pdf" target="_blank"> Corporate Strategic Plan</a></li>

                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </li>


                            <li></li>

                            <li>
                                <a href="#" class="uk-text-uppercase uk-light upSize">Admissions & Academics</a>
                                <div class="uk-navbar-dropdown uk-navbar-dropdown-width-4">
                                    <div class="uk-navbar-dropdown-grid uk-child-width-1-3" uk-grid>
                                        <!--<div>
                                            <ul class="uk-nav uk-navbar-dropdown-nav uk-text-left">
                                                <li class="uk-nav-header uk-text-capitalize">College & School</li>
                                                <li class="uk-nav-divider"></li>
                                                <li><a href="/Student_Guide.pdf" target="_blank"> Natural & Applied Science, Allied Health & Nursing</a></li>
                                                <li><a href="https://aeorion.ncu.edu.jm" target="_blank"> Education & Leadership</a></li>
                                                &lt;!&ndash; <li><a href="#">Student Involvement</a></li>&ndash;&gt;
                                                <li><a href="https://gmail.com" target="_blank"> Humanities, Behavioural & Social Sciences</a></li>
                                                <li><a href="https://www.ncu.edu.jm/library" target="_blank"> Business Management & Hospitality</a></li>
                                                <li><a href="http://transcripts.ncu.edu.jm/#/" target="_blank"> School of Religion</a></li>
                                                &lt;!&ndash;<li><a href="#">Virtual Tour</a></li>&ndash;&gt;
                                            </ul>
                                        </div>-->
                                        <div>
                                            <ul class="uk-nav uk-navbar-dropdown-nav uk-text-left">
                                                <li class="uk-nav-header uk-text-capitalize">Admissions</li>
                                                <li class="uk-nav-divider"></li>
                                               <!-- <li><router-link to="/generaladmission"> Apply for Admission</router-link></li>-->
                                                <!--<li><router-link to="/applicationforms"> Application Forms</router-link></li>-->
                                                <li><router-link to="/undergradadmission"> Undergraduate Admission</router-link></li>
                                                <li><router-link to="/graduateadmission"> Graduate Admission</router-link></li>

                                                <li><router-link to="/financialaid"> Financial Aid</router-link></li>


                                                <li><router-link to="/scholarshipandstudentaid"> Scholarship & Student Aid</router-link></li>
                                                <!--<li><router-link to="/arrangevisit"> Schedule A Visit</router-link></li>-->
                                                <li><router-link to="/tuitionfees"> Tuition & Fees</router-link></li>

                                            </ul>
                                        </div>
                                        <div>
                                            <ul class="uk-nav uk-navbar-dropdown-nav uk-text-left">
                                                <li class="uk-nav-header uk-text-capitalize">Academics</li>
                                                <li class="uk-nav-divider"></li>
                                                <li><router-link to="/academiccalendar">  Academic Calendar</router-link></li>
                                                <li><router-link to="/bulletins"> Bulletins</router-link></li>
                                                <li><router-link to="/certificateprograms"> Certificates & Diplomas</router-link></li>
                                                <li><router-link to="/collegeschools"> Colleges & School</router-link></li>
                                                <li><a href="https://distance.ncu.edu.jm" target="blank">Digital Education</a></li>

                                                <!--<li><a href="#">VEETI</a></li>-->
                                                <!--<li><a href="#">Academic Catalog</a></li>-->

                                                <li><router-link to="/extensionprograms"> Regional Campuses' Offerings</router-link></li>
                                                <li><router-link to="/gradprograms"> Graduate Programmes</router-link></li>
                                                <li><router-link to="/undergradprograms"> Undergraduate Programmes</router-link></li>


                                            </ul>
                                        </div>
                                        <div>
                                            <ul class="uk-nav uk-navbar-dropdown-nav uk-text-left">
                                                <li class="uk-nav-header uk-text-capitalize">General</li>
                                                <li class="uk-nav-divider"></li>
                                                <li><a href="https://aeorion.ncu.edu.jm" target="_blank"> Aeorion LMS</a></li>
                                                <li><a href="https://www.ncu.edu.jm/library" target="_blank"> Hiram Walters Resource Centre</a></li>
                                                <li><a href="https://gmail.com" target="_blank"> Student Email</a></li>
                                                <li><a href="/Student_Guide_Revised_July_3_2014.pdf" target="_blank"> Student Handbook</a></li>

                                               <!-- <li><a href="#">Student Involvement</a></li>-->


                                                <li><a href="http://transcripts.ncu.edu.jm/#/" target="_blank"> Transcript Requests</a></li>
                                                <!--<li><a href="#">Virtual Tour</a></li>-->
                                            </ul>
                                        </div>


                                    </div>
                                </div>
                            </li>
                            <li>
                                <a href="#" class="uk-text-uppercase uk-light upSize">Life at NCU</a>
                                <div class="uk-navbar-dropdown uk-navbar-dropdown-width-5">
                                    <div class="uk-navbar-dropdown-grid uk-child-width-1-4" uk-grid>
                                        <div>
                                            <ul class="uk-nav uk-navbar-dropdown-nav uk-text-left">
                                                <li class="uk-nav-header uk-text-capitalize">Social</li>
                                                <li class="uk-nav-divider"></li>
                                                <li><router-link to="/clubs"> Clubs</router-link></li>

                                                <!--<li><a href="#">Gospel Parties</a></li>-->
                                                <li><router-link to="/eventscalendar"> Events Calendar</router-link></li>
                                                <li><router-link to="/internationalstudents"> International Students</router-link></li>
                                            </ul>
                                        </div>
                                        <div>
                                            <ul class="uk-nav uk-navbar-dropdown-nav uk-text-left">
                                                <li class="uk-nav-header uk-text-capitalize">Physical</li>
                                                <li class="uk-nav-divider"></li>
                                                <!--<li><a href="#">Sports Day</a></li>-->
                                                <li><router-link to="/healthwellness"> Health And Wellness</router-link></li>
                                                <li><router-link to="/intercolsports"> Intercollegiate Sports</router-link></li>

                                            </ul>
                                        </div>
                                        <div>
                                            <ul class="uk-nav uk-navbar-dropdown-nav uk-text-left">
                                                <li class="uk-nav-header uk-text-capitalize">Mental</li>
                                                <li class="uk-nav-divider"></li>
                                                <li><router-link to="/counsellingpsychology"> Counselling</router-link></li>
                                                <li><a href="http://mec.ncu.edu.jm" target="_blank"> Entrepreneurship</a></li>
                                                <!--<li><a href="#">Lecture Series</a></li>-->
                                                <li><a href="/Student_Guide.pdf" target="_blank"> Student Guide</a></li>
                                            </ul>
                                        </div>
                                        <!--<div>
                                            <ul class="uk-nav uk-navbar-dropdown-nav uk-text-left">
                                                <li class="uk-nav-header uk-text-capitalize">Spiritual </li>
                                                <li class="uk-nav-divider"></li>
                                                <li><a href="#">Spiritual Activities</a></li>
                                                <li><a href="#">Prayer Garden</a></li>
                                                <li><a href="#">Chapel Sessions</a></li>
                                                <li><a href="#">Ellen G White Resource Center</a></li>
                                            </ul>
                                        </div>-->
                                        <div>
                                            <ul class="uk-nav uk-navbar-dropdown-nav uk-text-left">
                                                <li class="uk-nav-header uk-text-capitalize">General</li>
                                                <li class="uk-nav-divider"></li>
                                                <li><router-link to="/openinghours"> Campus Opening Hours</router-link></li>
                                                <li><router-link to="/campusliving"> Living on Campus</router-link></li>
                                                <li><router-link to="/publicsafety"> Public Safety</router-link></li>
                                              <li><a href="/Freshman_Survival_Kit_updated.pdf" target="_blank">University Survival Kit</a></li>

                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </li>
                          <li><router-link to="/contactus" class="uk-text-uppercase uk-light upSize"> Contact Us</router-link></li>


                        </ul>
                      <div class="uk-container uk-container-small uk-hidden@l">
                        <div class=" applybtn " id="applybtn" >
                          <a href="https://apply.ncu.edu.jm" target="_blank"
                             class="uk-text-uppercase uk-light uk-button upSize "
                             style="background: rgb(255, 215, 3); color:  #033860; border-radius: 5px; font-weight: bold; padding-left: 15px; padding-right: 15px; "
                          >Apply Now</a>
                        </div>
                      </div>
                        <div class="uk-navbar-item uk-visible@l">
                            <div>
                                <a href="https://apply.ncu.edu.jm" target="_blank"
                                   class="uk-text-uppercase uk-light uk-button upSize"
                                   style="background: rgb(255, 215, 3); color: #033860; border-radius: 5px; font-weight: bold; padding-left: 15px; padding-right: 15px;"
                                >Apply Now</a>
                            </div>
                        </div>

                        <!--Small Nav Bar-->
                        <div class="uk-navbar-right uk-hidden@l">
                            <a href="#offcanvas-slide" class="uk-button uk-button-link" uk-toggle><span uk-icon="menu" class="uk-text-muted" style="width:30px;margin-right: 20px"></span></a>

                            <div id="offcanvas-slide" uk-offcanvas>

                                <div class="uk-offcanvas-bar">

                                    <a href="http://www.ncu.edu.jm" class="uk-button-link uk-text-center  ">
                                        <img src="../../assets/ncu-logo2_inverted.png" style="padding: 10px; max-width: 350px; max-height: 350px; height: auto; width: auto;" alt="">
                                    </a>

                                    <div class="uk-width-1-1@s ">
                                        <ul class="uk-nav-default uk-nav-parent-icon" uk-nav="multiple: false">
                                            <li><router-link class="uk-heading-bullet" @click.native="closeOffCanvas()" to="/">Home</router-link></li>
                                            <li><a class="uk-heading-bullet"  @click.native="closeOffCanvas()" href="https://aeorion.ncu.edu.jm" target="_blank"> Aeorion LMS</a></li>
                                            <li class="uk-parent">
                                                <a class="uk-heading-bullet"  href="javascript:">About Us</a>
                                                <ul class="uk-nav-sub">


                                                    <li class="uk-nav-header uk-text-capitalize">School</li>
                                                    <li class="uk-nav-divider"></li>
                                                    <li><router-link class="uk-heading-bullet"  @click.native="closeOffCanvas()" to="/accreditation">  Accreditation & Affiliates</router-link></li>
                                                    <li><router-link class="uk-heading-bullet"  @click.native="closeOffCanvas()" to="/collegeschools"> Colleges & School</router-link></li>
                                                    <li><a class="uk-heading-bullet"  @click.native="closeOffCanvas()" href="/ETHOS_DOCUMENT.pdf"> Our Ethos</a></li>
                                                    <li><router-link class="uk-heading-bullet"  @click.native="closeOffCanvas()" to="/meetourleaders"> Meet Our Leaders</router-link></li>
                                                    <li class="uk-nav-header uk-text-capitalize">General</li>
                                                    <li class="uk-nav-divider"></li>


                                                    <li><router-link class="uk-heading-bullet" to="/adminunits" @click.native="closeOffCanvas()">Non-Academic Departments and Offices </router-link></li>
                                                    <li><router-link class="uk-heading-bullet" to="/futurencu" @click.native="closeOffCanvas()">Mission, Vision & Core Values </router-link></li>
                                                    <li><router-link class="uk-heading-bullet" to="/wearencu" @click.native="closeOffCanvas()"> Who we are  </router-link></li>
                                                    <li><a href="/NCUStrategicPlan2024FINAL.pdf" target="_blank" @click.native="closeOffCanvas()"> Corporate Strategic Plan</a></li>

                                                </ul>


                                            </li>

                                            <li class="uk-parent">
                                                <a class="uk-heading-bullet" href="#">Admissions & Academics </a>
                                                <ul class="uk-nav-sub">


                                                    <li class="uk-nav-header uk-text-capitalize">Admissions</li>
                                                    <li class="uk-nav-divider"></li>
                                                    <li><router-link class="uk-heading-bullet"  @click.native="closeOffCanvas()" to="/generaladmission"> Apply for Admission</router-link></li>
                                                    <li><router-link class="uk-heading-bullet"  @click.native="closeOffCanvas()" to="/undergradadmission"> Undergraduate Admission</router-link></li>
                                                    <li><router-link class="uk-heading-bullet"  @click.native="closeOffCanvas()" to="/graduateadmission"> Graduate Admission</router-link></li>
                                                    <!--<li><router-link class="uk-heading-bullet"  @click.native="closeOffCanvas()" to="/arrangevisit"> Schedule A Visit</router-link></li>-->
                                                    <li><router-link class="uk-heading-bullet"  @click.native="closeOffCanvas()" to="/financialaid"> Financial Aid</router-link></li>
                                                    <!--<li><router-link class="uk-heading-bullet"  @click.native="closeOffCanvas()" to="/applicationforms"> Application Forms</router-link></li>-->
                                                    <li><router-link class="uk-heading-bullet"  @click.native="closeOffCanvas()" to="/tuitionfees"> Tuition & Fees</router-link></li>
                                                    <li><router-link class="uk-heading-bullet"  @click.native="closeOffCanvas()" to="/scholarshipandstudentaid"> Scholarship & Student Aid</router-link></li>


                                                    <li class="uk-nav-header uk-text-capitalize">Academics</li>
                                                    <li class="uk-nav-divider"></li>
                                                    <li><a class="uk-heading-bullet"  @click.native="closeOffCanvas()" href="http://distance.ncu.edu.jm"> Distance Education</a></li>

                                                    <li><router-link class="uk-heading-bullet"  @click.native="closeOffCanvas()" to="/academiccalendar">  Academic Calendar</router-link></li>
                                                    <li><router-link class="uk-heading-bullet"  @click.native="closeOffCanvas()" to="/extensionprograms"> Regional Campuses' Offerings</router-link></li>
                                                    <li><router-link class="uk-heading-bullet"  @click.native="closeOffCanvas()" to="/certificateprograms"> Certificates & Diplomas</router-link></li>
                                                    <li><router-link class="uk-heading-bullet"  @click.native="closeOffCanvas()" to="/undergradprograms"> Undergraduate Programmes</router-link></li>
                                                    <li><router-link class="uk-heading-bullet"  @click.native="closeOffCanvas()" to="/gradprograms"> Graduate Programmes</router-link></li>
                                                    <li><router-link class="uk-heading-bullet"  @click.native="closeOffCanvas()"  to="/bulletins"> Bulletins</router-link></li>


                                                    <li class="uk-nav-header uk-text-capitalize">General</li>
                                                    <li class="uk-nav-divider"></li>
                                                    <li><a class="uk-heading-bullet"  @click.native="closeOffCanvas()" href="/Student_Guide_Revised_July_3_2014.pdf" target="_blank"> Student Handbook</a></li>
                                                    <li><a class="uk-heading-bullet"  @click.native="closeOffCanvas()" href="https://aeorion.ncu.edu.jm" target="_blank"> Aeorion LMS</a></li>

                                                    <li><a class="uk-heading-bullet"  @click.native="closeOffCanvas()" href="https://gmail.com" target="_blank"> Student Email</a></li>
                                                    <li><a class="uk-heading-bullet"  @click.native="closeOffCanvas()" href="https://www.ncu.edu.jm/library" target="_blank"> Hiram Walters Resource Centre</a></li>
                                                    <li><a class="uk-heading-bullet"  @click.native="closeOffCanvas()" href="http://transcripts.ncu.edu.jm/#/" target="_blank"> Transcript Requests</a></li>








                                                </ul>
                                            </li>


                                            <li class="uk-parent">
                                                <a class="uk-heading-bullet"  href="javascript:">Life at NCU</a>
                                                <ul class="uk-nav-sub">

                                                    <li class="uk-nav-header uk-text-capitalize">Social</li>
                                                    <li class="uk-nav-divider"></li>
                                                    <li><router-link class="uk-heading-bullet"  @click.native="closeOffCanvas()" to="/clubs"> Clubs</router-link></li>
                                                    <li><router-link class="uk-heading-bullet"  @click.native="closeOffCanvas()" to="/internationalstudents"> International Students</router-link></li>
                                                    <li><router-link class="uk-heading-bullet"  @click.native="closeOffCanvas()" to="/eventscalendar"> Events Calendar</router-link></li>

                                                    <li class="uk-nav-header uk-text-capitalize">Physical</li>
                                                    <li class="uk-nav-divider"></li>
                                                    <!--<li><a href="#">Sports Day</a></li>-->
                                                    <li><router-link class="uk-heading-bullet"  @click.native="closeOffCanvas()" to="/intercolsports"> Intercollegiate Sports</router-link></li>
                                                    <li><router-link  class="uk-heading-bullet"  @click.native="closeOffCanvas()" to="/healthwellness"> Health And Wellness</router-link></li>

                                                    <li class="uk-nav-header uk-text-capitalize">Mental</li>
                                                    <li class="uk-nav-divider"></li>
                                                    <li><router-link class="uk-heading-bullet"  @click.native="closeOffCanvas()" to="/counsellingpsychology"> Counselling</router-link></li>
                                                    <li><a class="uk-heading-bullet"  @click.native="closeOffCanvas()" href="http://mec.ncu.edu.jm" target="_blank"> Entrepreneurship</a></li>
                                                    <!--<li><a href="#">Lecture Series</a></li>-->
                                                    <li><a class="uk-heading-bullet"  @click.native="closeOffCanvas()" href="/Student_Guide.pdf" target="_blank"> Student Guide</a></li>


                                                    <li class="uk-nav-header uk-text-capitalize">General</li>
                                                    <li class="uk-nav-divider"></li>
                                                    <li><router-link  class="uk-heading-bullet"  @click.native="closeOffCanvas()" to="/openinghours"> Campus Opening Hours</router-link></li>
                                                    <li><router-link class="uk-heading-bullet"  @click.native="closeOffCanvas()" to="/campusliving"> Living on Campus</router-link></li>
                                                    <li><router-link class="uk-heading-bullet"  @click.native="closeOffCanvas()" to="/publicsafety"> Public Safety</router-link></li>


                                                </ul>


                                            </li>



                                           <li> <router-link to="/careers" class="uk-heading-bullet">Careers</router-link></li>
                                             <!--<li> <a href="https://news.ncu.edu.jm/CorporateDirectory/default.aspx?searchstring=&filterstring=&DepV=" target="_blank" class="uk-heading-bullet" >Directory</a></li>
                                            --><li><router-link to="/alumni" class="uk-heading-bullet"> Alumni</router-link></li>
                                           <li> <router-link to="/parents" class="uk-heading-bullet" > Parents</router-link></li>
                                            <li><router-link to="/newsandevents" class="uk-heading-bullet">News & Events</router-link></li>
                                            <li><router-link to="/students" class="uk-heading-bullet">Students</router-link></li>

                                            <li><router-link to="/giving" class="uk-heading-bullet" >Give</router-link></li>
                                            <li><router-link to="/contactus" class="uk-heading-bullet">Contact Us</router-link></li>
                                            <li><router-link to="/searchDepartment" class="uk-heading-bullet" >Department Directory</router-link></li>
                                            <li><a href="#" class="uk-heading-bullet" style=" text-decoration-color: gold"><u>Request Information</u></a></li>
                                            <li><a href="https://apply.ncu.edu.jm" target="_blank" class="uk-heading-bullet" style="color: rgb(255, 215, 3); font-weight: bold">Apply Now</a></li>
<!--                                            <li><router-link to="/dataProtection" class="uk-heading-bullet" >Data Protection</router-link></li>
                                            <li><router-link to="/privacy" class="uk-heading-bullet" >Privacy</router-link></li>-->
                                          <li class="uk-parent">
                                            <a class="uk-heading-bullet"  href="javascript:">More Links</a>
                                            <ul class="uk-nav-sub">

<!--                                              <li class="uk-nav-header uk-text-capitalize">Social</li>-->
                                              <li class="uk-nav-divider"></li>
                                              <li><router-link class="uk-heading-bullet"  @click.native="closeOffCanvas()" to="/records"> Records</router-link></li>
                                              <li><router-link to="/giving"  @click.native="closeOffCanvas()" class=" uk-text-small uk-light   uk-heading-bullet" >Give</router-link></li>
                                              <li><router-link to="/request_information"  @click.native="closeOffCanvas()" class="  uk-text-small  uk-heading-bullet" >Admissions Information</router-link></li>
                                              <li><a href="https://ncuadvance.org/" target="_blank" class="uk-heading-bullet" style="color: rgb(255, 215, 3); font-weight: bold">NCU Advance</a></li>

<!--                                              <li><router-link class="uk-heading-bullet"  @click.native="closeOffCanvas()" to="/internationalstudents"> International Students</router-link></li>
                                              <li><router-link class="uk-heading-bullet"  @click.native="closeOffCanvas()" to="/eventscalendar"> Events Calendar</router-link></li>-->

<!--
                                              <li class="uk-nav-header uk-text-capitalize">Physical</li>
                                              <li class="uk-nav-divider"></li>
                                              &lt;!&ndash;<li><a href="#">Sports Day</a></li>&ndash;&gt;
                                              <li><router-link class="uk-heading-bullet"  @click.native="closeOffCanvas()" to="/intercolsports"> Intercollegiate Sports</router-link></li>
                                              <li><router-link  class="uk-heading-bullet"  @click.native="closeOffCanvas()" to="/healthwellness"> Health And Wellness</router-link></li>

                                              <li class="uk-nav-header uk-text-capitalize">Mental</li>
                                              <li class="uk-nav-divider"></li>
                                              <li><router-link class="uk-heading-bullet"  @click.native="closeOffCanvas()" to="/counsellingpsychology"> Counselling</router-link></li>
                                              <li><a class="uk-heading-bullet"  @click.native="closeOffCanvas()" href="http://mec.ncu.edu.jm" target="_blank"> Entrepreneurship</a></li>
                                              &lt;!&ndash;<li><a href="#">Lecture Series</a></li>&ndash;&gt;
                                              <li><a class="uk-heading-bullet"  @click.native="closeOffCanvas()" href="/Student_Guide.pdf" target="_blank"> Student Guide</a></li>


                                              <li class="uk-nav-header uk-text-capitalize">General</li>
                                              <li class="uk-nav-divider"></li>
                                              <li><router-link  class="uk-heading-bullet"  @click.native="closeOffCanvas()" to="/openinghours"> Campus Opening Hours</router-link></li>
                                              <li><router-link class="uk-heading-bullet"  @click.native="closeOffCanvas()" to="/campusliving"> Living on Campus</router-link></li>
                                              <li><router-link class="uk-heading-bullet"  @click.native="closeOffCanvas()" to="/publicsafety"> Public Safety</router-link></li>

-->

                                            </ul>


                                          </li>


                                        </ul>

                                    </div>

                                </div>
                            </div>
                        </div>


                    </div>

                </nav>

            </div>
<!--            <div class="uk-navbar-dropbar" id="div2"></div>-->
        </div>
    </div>
</template>

<script>
    import UIkit from 'uikit'
    export default {
        name: "navbar",
        methods: {
            closeOffCanvas: function () {
                //UIkit.offcanvas('#offcanvas-usage').hide();
                //alert('blue ball')
                UIkit.offcanvas("#offcanvas-slide").hide();
                window.scrollTo(0, 0);
            },
          closeDropbar: function (){
            const editClass = document.querySelector('.uk-navbar-dropbar');
            //alert()
            editClass.style.height = '0px';
            const boxes = document.querySelectorAll('div.uk-open');

            boxes.forEach(box => {
              box.classList.remove("uk-open");
            });
           // UIkit.dropnav(".navi").offset(0);
          }
        }
    }
</script>

<style scoped>


    .topNav  * {
        /*font-family: 'Didact Gothic', sans-serif;
        font-family: 'Carrois Gothic SC', sans-serif;*/
        /*font-family: 'Sawarabi Gothic', sans-serif;*/
        /*font-family: 'Gothic A1', sans-serif;*/
        font-family: 'Nanum Gothic', sans-serif;
        font-size: 16px;
        font-variant: all-small-caps;
    }
    .uk-nav-header{
        color: teal !important;
        font-weight: bold;
        font-size: medium;
        font-variant: all-small-caps;

    }
    .upSize{
        font-size: 18px;
        font-weight: 600;
        color: rgb(255, 215, 3);
        font-family: 'PT Sans', sans-serif;
        font-variant: all-small-caps;
    }
    .upSize:hover{
        font-size: 18px;
        font-weight: 600;
        color: teal;
        font-family: 'PT Sans', sans-serif;
    }
    .topLinkColor{
        color: white;
    }
    img{
         max-width: 220px;
        max-height: 220px;
        height: auto;
        width: auto;
    }
    input::placeholder {
      color: gold;
      padding-left: 5px
    }
    @media screen and (min-width: 600px){
        img{
            padding: 10px;
            max-width: 250px;
            max-height: 250px;
            height: auto;
            width: auto;
        }
    }
    @media screen and (min-width: 960px){
        img{

            max-width: 300px;
            max-height: 300px;
            height: auto;
            width: auto;
        }
    }
    @media screen and (min-width: 1300px){
        img{

            max-width: 350px;
            max-height: 350px;
            height: auto;
            width: auto;
        }
    }



    @media screen and (min-width: 1400px) {
        nav {
        //width: 100% !important;
        }
        img{

            max-width: 440px;
            max-height: 440px;
            height: auto;
            width: auto;
        }

    }

    .applybtn{
      padding: 20px;

    }

    @media screen and (max-width: 495px)  {
      #applybtn{ display: none;}
    }


</style>
